import { render, staticRenderFns } from "./CareerMajor.vue?vue&type=template&id=e4aa1700&scoped=true"
import script from "./CareerMajor.vue?vue&type=script&lang=js"
export * from "./CareerMajor.vue?vue&type=script&lang=js"
import style0 from "./CareerMajor.vue?vue&type=style&index=0&id=e4aa1700&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4aa1700",
  null
  
)

export default component.exports